module.exports = __webpack_public_path__ + "i18n/pl.88f2db9226149a689f513fe6b2538c5f.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=i18n/[name].[hash].[ext]!./i18n/pl.json
// module id = 1290
// module chunks = 60